import { render } from "./PdfActionsGadget.vue?vue&type=template&id=12ab3674&scoped=true"
import script from "./PdfActionsGadget.vue?vue&type=script&lang=js"
export * from "./PdfActionsGadget.vue?vue&type=script&lang=js"

import "./PdfActionsGadget.vue?vue&type=style&index=0&id=12ab3674&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ab3674"]])

export default __exports__